"use client";

import { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import api from "../../services/api";
import AsyncSelect from "react-select/async";
import Swal from "sweetalert2";
import { toast } from "react-toastify";


const UserSelect = ({ value, onChange }) => {
  const loadOptions = async (input) => {
    if (!input || input.length < 2) return [];

    const { data } = await api.get("/admin/users", {
      params: { search: input, perPage: 20 },
    });

    return data.items.map((u) => ({
      value: u.id,
      label: `${u.name} ${u.family} (${u.mobile || "-"})`,
    }));
  };

  return (
    <AsyncSelect
      cacheOptions
      loadOptions={loadOptions}
      value={value}
      onChange={onChange}
      isClearable
      placeholder="انتخاب کاربر"
      styles={{ menu: (p) => ({ ...p, zIndex: 9999 }) }}
    />
  );
};

const NotificationFormModal = ({ show, onHide, notification, onSuccess }) => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  //const [userId, setUserId] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [channel, setChannel] = useState("PANEL");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (notification) {
      setTitle(notification.title);
      setMessage(notification.message);
      //setUserId(notification.user?.id || "");
      setSelectedUser(
        notification?.user
            ? {
                value: notification.user.id,
                label: `${notification.user.name} ${notification.user.family} (${notification.user.mobile || "-"})`,
            }
            : null
      );
      setChannel(notification.channels?.[0]?.channel || "PANEL");
    } else {
      setTitle("");
      setMessage("");
      //setUserId("");
      setSelectedUser(null);
      setChannel("PANEL");
    }
  }, [notification]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = {
        title,
        message,
        //userId: Number(userId),
        userId: selectedUser?.value,
        channels: [channel],
        type: "SYSTEM",
        priority: "NORMAL",
      };

      if (!selectedUser) {
        toast.error("لطفاً کاربر را انتخاب کنید");
        setLoading(false);
        return;
      }

      if (notification) {
        await api.patch(`/notifications/${notification.id}`, payload);
        toast.success("اعلان ویرایش شد");
      } else {
        await api.post("/notifications", payload);
        toast.success("اعلان ایجاد شد");
      }

      onSuccess();
      onHide();
    } catch (err) {
      toast.error(err.response?.data?.message || "خطا در ذخیره اعلان");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} style={{'direction':'rtl'}}>
      <Form onSubmit={submit}>
        <Modal.Header closeButton>
          <Modal.Title>
            {notification ? "ویرایش اعلان" : "افزودن اعلان"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>ID کاربر</Form.Label>
            {/* <Form.Control
              type="number"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
            /> */}
            <UserSelect value={selectedUser} onChange={setSelectedUser} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>عنوان</Form.Label>
            <Form.Control
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>متن پیام</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>کانال</Form.Label>
            <Form.Select
              value={channel}
              onChange={(e) => setChannel(e.target.value)}
            >
              <option value="PANEL">پنل</option>
              <option value="SMS">SMS</option>
              <option value="PUSH">Push</option>
            </Form.Select>
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            انصراف
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? "در حال ذخیره..." : "ذخیره"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default NotificationFormModal;
